import { Grid, Pagination } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useStore } from "utils/useStore";
import ConversationsStore from "../../../Stores/ConversationsStore";
import UnfocusedConversationList from "./UnfocusedConversationList";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";

type Props = {};

const UnfocusedConversationWrapper: React.FC<Props> = observer(() => {
    const store = useStore(ConversationsStore);
    const haveResults =
        !!store?.conversationsList?.length || store.pageNumber !== 1;

    const location = useLocation();

    useEffect(() => {
        if (store.selectedConversationId) {
            store.setSelectedConversationId(undefined);
        }
    }, [location, store]);

    const totalPages = Math.ceil((store.estimatedConversationCount ?? 0) / 10);

    const conversationsPagination = (
        <Grid
            container
            item
            xs={12}
            sx={{ maxHeight: "50px", margin: "20px 0px" }}
        >
            <Grid
                container
                item
                xs={12}
                justifyContent="flex-end"
                alignItems="center"
            >
                <Grid item>
                    <Pagination
                        variant="outlined"
                        color="primary"
                        count={totalPages}
                        page={store.pageNumber}
                        onChange={(evt, val) => {
                            store.setPageNumberAndGetConversations(val);
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );

    return (
        <Grid container alignContent={haveResults ? "flex-start" : "center"}>
            {
                <Grid container item xs={12} direction="column">
                    {store?.estimatedConversationCount ? (
                        <UnfocusedConversationList />
                    ) : (
                        <AcxEmptyState
                            size="large"
                            variant={
                                store.loadConversationsFailed
                                    ? "error"
                                    : "empty"
                            }
                        />
                    )}
                </Grid>
            }
            {haveResults && conversationsPagination}
        </Grid>
    );
});

export default UnfocusedConversationWrapper;
